"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  NativeSafeAreaProvider: () => import_OneNativeSafeAreaProviderNativeComponent.default,
  buildSafeAreaInsetStyle: () => import_insets.buildSafeAreaInsetStyle,
  getInitialWindowMetrics: () => getInitialWindowMetrics,
  keyboardSafeBottom: () => import_insets.keyboardSafeBottom,
  providerEventToMetrics: () => import_insets.providerEventToMetrics,
  resolveOverlappingInsets: () => import_insets.resolveOverlappingInsets,
  resolveSafeAreaEdgeModes: () => import_insets.resolveSafeAreaEdgeModes
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_OneNativeSafeAreaProviderNativeComponent = __toESM(require("../specs/OneNativeSafeAreaProviderNativeComponent"), 1);
var import_insets = require("./insets");
function getInitialWindowMetrics() {
  var module2 = import_react_native.TurboModuleRegistry.get("OneNativeSafeAreaContext");
  if (!module2) return null;
  var constants = typeof module2.getConstants === "function" ? module2.getConstants() : module2;
  var metrics = constants === null || constants === void 0 ? void 0 : constants.initialWindowMetrics;
  return isMetrics(metrics) ? metrics : null;
}
function isMetrics(value) {
  if (!value || typeof value !== "object") return false;
  var { insets, frame } = value;
  if (!insets || typeof insets !== "object" || !frame || typeof frame !== "object") return false;
  var numbers = [
    insets.top,
    insets.right,
    insets.bottom,
    insets.left,
    frame.x,
    frame.y,
    frame.width,
    frame.height
  ];
  return numbers.every(function(number) {
    return typeof number === "number" && Number.isFinite(number);
  });
}
//# sourceMappingURL=index.native.js.map
